import { render, staticRenderFns } from "./AppChip.vue?vue&type=template&id=45dc692c&scoped=true&"
import script from "./AppChip.vue?vue&type=script&lang=js&"
export * from "./AppChip.vue?vue&type=script&lang=js&"
import style0 from "./AppChip.vue?vue&type=style&index=0&id=45dc692c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dc692c",
  null
  
)

export default component.exports